export type ScopedTripEmploymentChoice = { ready: boolean; id?: string; requiresChoice: boolean; scope: string }
/** Never send a partial list: the server pairs each job with the participant at its index. */
export function tripEmploymentSelection(
  participantIds: string[],
  initiatorId: string | undefined,
  employmentId: string | undefined,
  companyId: string | undefined,
  scope: string,
  choices: Record<string, ScopedTripEmploymentChoice>,
): { ready: boolean; employeeEmploymentIds?: string[] } {
  const targets = participantIds.filter(id => id !== initiatorId)
  const states = targets.map(id => choices[id]?.scope === scope ? choices[id] : undefined)
  const targetIds = participantIds.map(id => id === initiatorId ? employmentId : choices[id]?.scope === scope ? choices[id].id : undefined)
  const complete = targetIds.every((id): id is string => !!id)
  return {
    ready: (!companyId || states.every(choice => choice?.ready)) && (complete || !states.some(choice => choice?.requiresChoice)),
    employeeEmploymentIds: complete ? targetIds as string[] : undefined,
  }
}
